import { render, staticRenderFns } from "./localization.vue?vue&type=template&id=7c15f347&scoped=true"
import script from "./localization.vue?vue&type=script&lang=js"
export * from "./localization.vue?vue&type=script&lang=js"
import style0 from "./localization.vue?vue&type=style&index=0&id=7c15f347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c15f347",
  null
  
)

export default component.exports